if (!customElements.get('zoomio-countdown')) {
customElements.define('zoomio-countdown', class extends HTMLElement {
// Cycles de 5 jours identiques pour tous les visiteurs, comptés depuis le 22/10/2026 à 0 h (heure de Paris).
nextEnd() {
const start = Date.UTC(2026, 9, 21, 22, 0, 0), cycle = 5 * 24 * 60 * 60 * 1000;
return start + (Math.floor((Date.now() - start) / cycle) + 1) * cycle;
}
connectedCallback() {
this.end = this.nextEnd();
if (!Number.isFinite(this.end)) { this.hidden = true; return; }
this.hidden = false;
this.tick();
this.timer = setInterval(() => this.tick(), 1000);
}
disconnectedCallback() { clearInterval(this.timer); }
tick() {
if (this.end <= Date.now()) this.end = this.nextEnd();
const remaining = Math.max(0, Math.ceil((this.end - Date.now()) / 1000));
const values = [Math.floor(remaining / 86400), Math.floor(remaining / 3600) % 24, Math.floor(remaining / 60) % 60, remaining % 60];
this.querySelectorAll('[data-unit]').forEach((node, i) => { node.textContent = String(values[i]).padStart(2, '0'); });
}
});
}
if (!customElements.get('zoomio-gallery')) {
customElements.define('zoomio-gallery', class extends HTMLElement {
connectedCallback() {
if (this.ready) return;
this.ready = true;
zoomioInitPhotoZoom(this);
this.addEventListener('click', event => {
const button = event.target.closest('[data-gallery-src]');
if (!button || !this.contains(button)) return;
const main = this.querySelector('.zo-photo img');
if (!main) return;
main.removeAttribute('srcset');
main.removeAttribute('sizes');
main.src = button.dataset.gallerySrc;
main.alt = button.dataset.galleryAlt || '';
this.querySelectorAll('[data-gallery-src]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
const caption = this.querySelector('figcaption');
if (caption) caption.hidden = button !== this.querySelector('[data-gallery-src]');
const badges = this.querySelector('.zo-photo-badges');
if (badges) badges.hidden = true;
});
}
});
}
// Zoom des photos produit : carré-loupe + fenêtre de zoom à côté de la photo (ordinateur), agrandissement plein écran au clic ou au toucher.
function zoomioHiRes(src){try{const url=new URL(src,location.href);url.searchParams.set('width','2400');return url.href;}catch(e){return src;}}
function zoomioInitPhotoZoom(gallery){
const photo=gallery.querySelector('.zo-photo');const img=photo&&photo.querySelector('img');
if(!img)return;
img.tabIndex=0;img.setAttribute('role','button');img.setAttribute('aria-label','Agrandir la photo');img.setAttribute('aria-haspopup','dialog');
const mouse=window.matchMedia('(hover: hover) and (pointer: fine)'),factor=2.5;
const lens=document.createElement('div');lens.className='zo-lens';lens.setAttribute('aria-hidden','true');lens.hidden=true;photo.appendChild(lens);
const pane=document.createElement('div');pane.className='zo-zoom-pane';pane.setAttribute('aria-hidden','true');pane.hidden=true;(gallery.closest('.zo-layout')||gallery).appendChild(pane);
const hide=()=>{lens.hidden=true;pane.hidden=true;};
photo.addEventListener('mousemove',e=>{
const r=img.getBoundingClientRect();
// Fenêtre seulement s'il y a la place à droite de la photo (grand écran, deux colonnes).
if(!mouse.matches||window.innerWidth<750||window.innerWidth-r.right<r.width*0.8){hide();return;}
const src=zoomioHiRes(img.currentSrc||img.src);
if(pane.dataset.src!==src){pane.dataset.src=src;pane.style.backgroundImage='url("'+src+'")';}
const size=r.width/factor,x=Math.min(Math.max(e.clientX-r.left-size/2,0),r.width-size),y=Math.min(Math.max(e.clientY-r.top-size/2,0),r.height-size);
lens.style.cssText='width:'+size+'px;height:'+size+'px;left:'+(img.offsetLeft+x)+'px;top:'+(img.offsetTop+y)+'px';
const box=pane.parentElement.getBoundingClientRect();
pane.style.width=r.width+'px';pane.style.height=r.height+'px';pane.style.top=(r.top-box.top)+'px';pane.style.left=(r.right-box.left+24)+'px';
pane.style.backgroundSize=(r.width*factor)+'px '+(r.height*factor)+'px';pane.style.backgroundPosition=(-x*factor)+'px '+(-y*factor)+'px';
lens.hidden=false;pane.hidden=false;
});
photo.addEventListener('mouseleave',hide);
img.addEventListener('click',()=>zoomioOpenLightbox(gallery));
img.addEventListener('keydown',e=>{if(e.key==='Enter'||e.key===' '){e.preventDefault();zoomioOpenLightbox(gallery);}});
}
function zoomioLightbox(){
let box=document.getElementById('zoomio-lightbox');
if(box)return box;
box=document.createElement('dialog');box.id='zoomio-lightbox';box.className='zo-lightbox';box.setAttribute('aria-label','Photo agrandie');
box.innerHTML='<div class="zo-lb-stage"><img alt=""></div><button class="zo-lb-btn zo-lb-close" type="button" aria-label="Fermer">&times;</button><button class="zo-lb-btn zo-lb-prev" type="button" aria-label="Photo précédente">&lsaquo;</button><button class="zo-lb-btn zo-lb-next" type="button" aria-label="Photo suivante">&rsaquo;</button><p class="zo-lb-hint"></p>';
document.body.appendChild(box);
const stage=box.querySelector('.zo-lb-stage'),img=stage.querySelector('img');
const unzoom=()=>{stage.classList.remove('is-zoomed');img.style.width='';};
box.show=i=>{const n=box.items.length;box.index=(i+n)%n;unzoom();img.src=zoomioHiRes(box.items[box.index].src);img.alt=box.items[box.index].alt;};
img.addEventListener('click',e=>{
e.stopPropagation();
if(stage.classList.contains('is-zoomed')){unzoom();return;}
const r=img.getBoundingClientRect(),px=(e.clientX-r.left)/r.width,py=(e.clientY-r.top)/r.height;
stage.classList.add('is-zoomed');img.style.width=Math.round(Math.max(stage.clientWidth,stage.clientHeight)*2.2)+'px';
stage.scrollLeft=px*img.offsetWidth-stage.clientWidth/2;stage.scrollTop=py*img.offsetHeight-stage.clientHeight/2;
});
stage.addEventListener('click',()=>box.close());
box.querySelector('.zo-lb-close').addEventListener('click',()=>box.close());
box.querySelector('.zo-lb-prev').addEventListener('click',()=>box.show(box.index-1));
box.querySelector('.zo-lb-next').addEventListener('click',()=>box.show(box.index+1));
box.addEventListener('keydown',e=>{if(box.items.length<2)return;if(e.key==='ArrowLeft')box.show(box.index-1);if(e.key==='ArrowRight')box.show(box.index+1);});
let startX=null;
stage.addEventListener('touchstart',e=>{startX=e.touches.length===1&&!stage.classList.contains('is-zoomed')?e.touches[0].clientX:null;},{passive:true});
stage.addEventListener('touchend',e=>{if(startX===null||box.items.length<2)return;const dx=e.changedTouches[0].clientX-startX;if(Math.abs(dx)>50)box.show(box.index+(dx<0?1:-1));startX=null;});
box.addEventListener('close',()=>{unzoom();document.documentElement.classList.remove('zo-lb-open');});
return box;
}
function zoomioOpenLightbox(gallery){
const main=gallery.querySelector('.zo-photo img');if(!main)return;
const path=s=>(s||'').split('?')[0];
const items=[...gallery.querySelectorAll('[data-gallery-src]')].map(b=>({src:b.dataset.gallerySrc,alt:b.dataset.galleryAlt||''}));
let index=items.findIndex(item=>path(item.src)===path(main.currentSrc||main.src));
if(index<0){items.unshift({src:main.src,alt:main.alt});index=0;}
const box=zoomioLightbox();
box.items=items;box.classList.toggle('is-single',items.length<2);
box.querySelector('.zo-lb-hint').textContent=window.matchMedia('(hover: hover)').matches?'Cliquez sur la photo pour zoomer':'Touchez la photo pour zoomer';
box.show(index);
document.documentElement.classList.add('zo-lb-open');
box.showModal();
}
function zoomioShowPackImage(form,pack){const gallery=form.closest('.zo-layout')?.querySelector('zoomio-gallery');const main=gallery?.querySelector('.zo-photo img');if(!main)return;const first=gallery.querySelector('[data-gallery-src]');const src=pack.dataset.image||(first&&first.dataset.gallerySrc);if(!src||(main.getAttribute('src')||'').split('?')[0]===src.split('?')[0])return;main.removeAttribute('srcset');main.removeAttribute('sizes');main.src=src;main.alt=pack.dataset.imageAlt||(first&&first.dataset.galleryAlt)||main.alt;gallery.querySelectorAll('[data-gallery-src]').forEach(b=>b.setAttribute('aria-pressed',String(!pack.dataset.image&&b===first)));}
function zoomioRenderBadges(form,pack){
const photo=form.closest('.zo-layout')?.querySelector('zoomio-gallery .zo-photo');
if(!photo)return;
let box=photo.querySelector('.zo-photo-badges');
if(!box){box=document.createElement('div');box.className='zo-photo-badges';box.setAttribute('aria-hidden','true');photo.appendChild(box);}
if(!pack.dataset.image){box.hidden=true;return;}
const card=pack.closest('.zo-choice');
const text=sel=>card.querySelector(sel)?.textContent.trim()||'';
const el=(tag,cls,content)=>{const node=document.createElement(tag);node.className=cls;if(content)node.append(...content);return node;};
const children=[];
if(text('.zo-discount'))children.push(el('span','zo-pb zo-pb-discount',[text('.zo-discount')]));
const price=el('span','zo-pb zo-pb-price',[el('strong','zo-pb-now',[pack.dataset.price])]);
if(text('.zo-compare s'))price.append(el('span','zo-pb-was',['au lieu de ',el('s','',[text('.zo-compare s')])]));
if(text('.zo-per'))price.append(el('span','zo-pb-unit',[text('.zo-per')]));
children.push(price);
box.replaceChildren(...children);
box.hidden=false;
}
function initZoomioPurchase(root=document){root.querySelectorAll('[data-zoomio-purchase]').forEach(form=>{if(form.dataset.ready)return;form.dataset.ready='true';const sync=()=>{const pack=form.querySelector('input[name="zoomio-bundle"]:checked');if(!pack)return;const available=pack.dataset.available==='true'&&pack.dataset.variant;const compare=pack.closest('.zo-choice').querySelector('.zo-compare s');form.querySelector('[name="id"]').value=pack.dataset.variant||'';const stock=form.querySelector('.zo-stock');if(stock)stock.hidden=!available||pack.dataset.lowStock!=='true';zoomioShowPackImage(form,pack);zoomioRenderBadges(form,pack);const button=form.querySelector('.zo-submit');button.disabled=!available;const label=button.querySelector('[data-cart-label]');if(label){label.textContent=available?'Ajouter au panier':'Indisponible';button.querySelector('#bundle-price').textContent=pack.dataset.price;const buttonCompare=button.querySelector('#bundle-compare');buttonCompare.textContent=compare?compare.textContent:'';buttonCompare.hidden=!compare;}else{button.textContent=(available?'Ajouter au panier · ':'Indisponible · ')+pack.dataset.price;}};form.addEventListener('change',()=>{sync();zoomioSyncUrl(form);});sync();});}function zoomioSyncUrl(form){/* Sur la fiche produit, l'adresse suit le pack choisi (lien partageable). */if(!location.pathname.includes('/products/'))return;const id=form.querySelector('[name="id"]').value;if(!id)return;const url=new URL(location.href);url.searchParams.set('variant',id);history.replaceState(history.state,'',url);}initZoomioPurchase();document.addEventListener('shopify:section:load',e=>initZoomioPurchase(e.target));


if (!customElements.get('zoomio-sticky-cart')) {
customElements.define('zoomio-sticky-cart', class extends HTMLElement {
connectedCallback() {
this.form=document.getElementById(this.dataset.formId);
this.section=this.closest('.zoomio-product');
if(!this.form||!this.section)return;
this.controller=new AbortController();
const options={signal:this.controller.signal};
this.select=this.querySelector('select');
this.button=this.querySelector('button');
this.sync=()=>{
const pack=this.form.querySelector('[name="zoomio-bundle"]:checked');
if(!pack)return;
const card=pack.closest('.zo-choice');
this.select.value=pack.value;
this.querySelector('.zsc-price').textContent=pack.dataset.price;
const compare=card.querySelector('.zo-compare s');
const discount=card.querySelector('.zo-discount');
const stickyCompare=this.querySelector('.zsc-prices s');
stickyCompare.textContent=compare?compare.textContent:'';
stickyCompare.hidden=!compare;
const stickyDiscount=this.querySelector('.zsc-discount');
stickyDiscount.textContent=discount?discount.textContent:'';
stickyDiscount.hidden=!discount;
this.querySelector('.zsc-gift').hidden=!card.querySelector('.zo-gift');
const photo=this.querySelector('.zsc-photo');
if(photo){this.defaultPhoto??=photo.src;photo.src=pack.dataset.image?pack.dataset.image.replace(/width=\d+/,'width=160'):this.defaultPhoto;}
this.button.disabled=pack.dataset.available!=='true'||!pack.dataset.variant;
this.button.textContent=this.button.disabled?'Indisponible':'Ajouter au panier';
this.select.querySelectorAll('option').forEach(option=>{
const radio=this.form.querySelector('[name="zoomio-bundle"][value="'+option.value+'"]');
option.disabled=!radio||radio.dataset.available!=='true'||!radio.dataset.variant;
});
};
this.form.addEventListener('change',this.sync,options);
this.select.addEventListener('change',()=>{
const radio=this.form.querySelector('[name="zoomio-bundle"][value="'+this.select.value+'"]');
if(radio){radio.checked=true;radio.dispatchEvent(new Event('change',{bubbles:true}));}
},options);
this.button.addEventListener('click',()=>{
const submit=this.form.querySelector('.zo-submit');
if(submit&&!submit.disabled)this.form.requestSubmit(submit);
},options);
this.updateSpace=()=>{document.documentElement.style.setProperty('--zoomio-sticky-space',this.hidden?'0px':this.offsetHeight+'px');};
this.observer=new IntersectionObserver(entries=>{
const entry=entries[0];
this.hidden=entry.boundingClientRect.bottom>0||entry.isIntersecting;
document.body.classList.toggle('zoomio-has-sticky',!this.hidden);
this.updateSpace();
},{threshold:0});
this.observer.observe(this.section);
this.resizeObserver=new ResizeObserver(this.updateSpace);
this.resizeObserver.observe(this);
this.sync();
}
disconnectedCallback(){
this.controller?.abort();
this.observer?.disconnect();
this.resizeObserver?.disconnect();
document.body.classList.remove('zoomio-has-sticky');
document.documentElement.style.removeProperty('--zoomio-sticky-space');
}
});
}
// Menu mobile : se referme après un clic sur un lien, avec Échap ou en touchant à côté.
document.addEventListener('click',e=>{document.querySelectorAll('details.zm-mobile[open]').forEach(menu=>{if(!menu.contains(e.target)||e.target.closest('.zm-mobile-links a'))menu.open=false;});});
document.addEventListener('keydown',e=>{if(e.key==='Escape')document.querySelectorAll('details.zm-mobile[open]').forEach(menu=>{menu.open=false;menu.querySelector('summary').focus();});});
// Anti-spam : l'adresse n'est jamais écrite en clair dans le code des pages (« bonjour [arobase] zoomio.fr ») ; elle devient un lien cliquable à l'affichage.
(()=>{const hidden='bonjour [arobase] zoomio.fr',mail='bonjour'+String.fromCharCode(64)+'zoomio.fr';const walker=document.createTreeWalker(document.body,NodeFilter.SHOW_TEXT,{acceptNode:n=>n.nodeValue.includes(hidden)?NodeFilter.FILTER_ACCEPT:NodeFilter.FILTER_REJECT});const nodes=[];while(walker.nextNode())nodes.push(walker.currentNode);nodes.forEach(node=>{const parts=node.nodeValue.split(hidden);const frag=document.createDocumentFragment();parts.forEach((part,i)=>{if(i){const a=document.createElement('a');a.href='mailto:'+mail;a.textContent=mail;frag.append(a);}frag.append(part);});node.replaceWith(frag);});})();
